import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import axios from 'axios';
import { Button, Progress, List } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:10000";

function BatchUpload() {
    const [uploadQueue, setUploadQueue] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const fileInputRef = React.useRef(null);

    const handleFolderSelect = (event) => {
        const files = Array.from(event.target.files);
        const videoFiles = files.filter(file => file.name.endsWith('.mp4'));
        
        const initialQueue = videoFiles.map(file => ({
            file,
            status: 'pending',
            progress: 0,
            error: null
        }));
        
        setUploadQueue(initialQueue);
    };

    const startBatchUpload = async () => {
        if (uploadQueue.length === 0 || isUploading) return;
        setIsUploading(true);

        for (let i = 0; i < uploadQueue.length; i++) {
            const item = uploadQueue[i];
            
            // Update status to uploading
            updateItemStatus(i, { status: 'uploading' });

            try {
                // 1. Get Pre-signed URL from Backend
                const urlResponse = await axios.get(`${API_BASE_URL}/generate-presigned-url`, {
                    params: { fileName: item.file.name }
                });
                const presignedUrl = urlResponse.data.url;

                // 2. Upload directly to S3
                await axios.put(presignedUrl, item.file, {
                    headers: { 'Content-Type': item.file.type },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        updateItemStatus(i, { progress: percentCompleted });
                    }
                });

                // 3. Notify Backend to save metadata
                const title = item.file.name.replace(/\.[^/.]+$/, ""); // Strips any extension
                await axios.post(`${API_BASE_URL}/upload`, null, {
                    params: {
                        video_name: item.file.name,
                        title: title
                    }
                });

                updateItemStatus(i, { status: 'completed', progress: 100 });
            } catch (err) {
                console.error(`Failed to upload ${item.file.name}`, err);
                updateItemStatus(i, { status: 'error', error: err.message });
            }
        }

        setIsUploading(false);
        alert("Batch upload process finished!");
    };

    const updateItemStatus = (index, updates) => {
        setUploadQueue(prev => {
            const newQueue = [...prev];
            newQueue[index] = { ...newQueue[index], ...updates };
            return newQueue;
        });
    };

    return (
        <div className="App">
            <Navbar />
            <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
                <h3>Batch Video Upload</h3>
                <p>Select a folder to upload all .mp4 videos directly to S3.</p>
                <br />
                
                <div style={{ marginBottom: '20px' }}>
                    <input 
                        type="file" 
                        webkitdirectory="true" 
                        directory="true" 
                        onChange={handleFolderSelect} 
                        style={{ display: 'none' }} 
                        ref={fileInputRef}
                    />
                    <Button appearance="ghost" onClick={() => fileInputRef.current.click()}>
                        Select Folder
                    </Button>
                    
                    <Button 
                        appearance="primary" 
                        color="green" 
                        onClick={startBatchUpload} 
                        disabled={uploadQueue.length === 0 || isUploading}
                        style={{ marginLeft: '10px' }}
                    >
                        Start Upload ({uploadQueue.length} videos)
                    </Button>
                </div>

                <List bordered>
                    {uploadQueue.map((item, index) => (
                        <List.Item key={index}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ width: '40%' }}>
                                    <strong>{item.file.name}</strong>
                                    {item.error && <div style={{ color: 'red', fontSize: '12px' }}>{item.error}</div>}
                                </div>
                                <div style={{ width: '40%' }}>
                                    <Progress.Line 
                                        percent={item.progress} 
                                        status={item.status === 'error' ? 'active' : (item.status === 'completed' ? 'success' : 'active')} 
                                    />
                                </div>
                                <div style={{ width: '15%', textAlign: 'right' }}>
                                    {item.status.toUpperCase()}
                                </div>
                            </div>
                        </List.Item>
                    ))}
                </List>
            </div>
        </div>
    );
}

export default BatchUpload;
